import { render } from "./signature.vue?vue&type=template&id=2b90b7b0&scoped=true"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"

import "./signature.vue?vue&type=style&index=0&id=2b90b7b0&scoped=true&lang=less"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b90b7b0"]])

export default __exports__